import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import styles from './styles/about-05.module.css';

import {ReactComponent as MembersImg} from '../../assets/about05/members.svg'

const textMotion = {
    hidden: {
        opacity: 0,
        y: -50
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            mass: 1,
            stiffness: 28.44,
            damping: 10
        }
    }
};

export default function About05() {
    const ref = useRef(null);
        
    const isInView = useInView(ref, {
        once: true,
        amount: 0.3,
        margin: '-100px 0px'
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.containerImg}>
                <MembersImg preserveAspectRatio="xMidYMid slice" />
            </div>
            <div className={styles.containerText}>
                <p className={styles.title}>디피니트가 꿈꾸는 미래</p>
                <div className={styles.futureList} ref={ref}>
                    <div className={styles.boxFuture}>
                        <p>우리의 목표</p>
                        <motion.p
                            initial='hidden'
                            animate={isInView ? 'visible' : 'hidden'}
                            variants={textMotion}
                        >
                            2029년까지 전 세계 1,000개 기업의 디지털 혁신을 지원하여 '1기업 1다비스' 시대를 열어가겠습니다.
                        </motion.p>
                    </div>
                    <div className={styles.boxFuture}>
                        <p>함께 성장하는 팀</p>
                        <motion.p
                            initial='hidden'
                            animate={isInView ? 'visible' : 'hidden'}
                            variants={textMotion}
                        >
                            세상에 위대한 사람은 없습니다. 단지 평범한 사람들의 위대한 도전이 있을 뿐입니다. 우리는 함께이기에 불가능한 도전도 현실로 만들어갑니다.
                        </motion.p>
                    </div>
                </div>
            </div>
        </div>
    );
}
